import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from 'src/app/shared/session';
import { SessionInfo } from 'src/app/shared/session/SessionInfo';
import { RolParametroAutonomia } from './rol-parametro-autonomia.model';

@Injectable({
  providedIn: 'root'
})
export class RolParametroAutonomiaService {

  constructor(private dataService: DataService, private sessionInfo: SessionInfo) { }

  private listarRolParametroAutonomiaPorUrl: string = 'rolParametroAutonomia/listarPor';
  private obtenerRolParametroAutonomiaUrl: string = 'rolParametroAutonomia/obtener';
  private saveRolParametroAutonomiaUrl: string = 'rolParametroAutonomia/save';

  listarRolParametroAutonomia(filtro: string, idRol?: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", filtro);
    parameters = parameters.append("idEmpresa", String(this.sessionInfo.getEmpresaID()));
    parameters = parameters.append("idRol", idRol != null ? String(idRol) : null);
    this.dataService.set(this.listarRolParametroAutonomiaPorUrl);
    return this.dataService.execGetJson(parameters);
  }

  obtenerRolParametroAutonomia(idRol: number, idParametroAutonomia: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("idRol", String(idRol));
    parameters = parameters.append("idParametroAutonomia", String(idParametroAutonomia));
    parameters = parameters.append("idEmpresa", String(this.sessionInfo.getEmpresaID()));
    this.dataService.set(this.obtenerRolParametroAutonomiaUrl);
    return this.dataService.execGetJson(parameters);
  }

  guardarRolParametroAutonomia(rolParametroAutonomia: RolParametroAutonomia): any {
    let parameters: string;
    parameters = JSON.stringify({
      idRol: rolParametroAutonomia.idRol,
      idParametroAutonomia: rolParametroAutonomia.idParametroAutonomia,
      idEmpresa: this.sessionInfo.getEmpresaID(),
      valorMin: rolParametroAutonomia.valorMin,
      valorMax: rolParametroAutonomia.valorMax,
      userSave: this.sessionInfo.getCodUsuario(),
    });
    this.dataService.set(this.saveRolParametroAutonomiaUrl);
    return this.dataService.execPostJson(parameters);
  }
}
